import { UNI_CARD_DISPLAY_NAME } from "./core";
import createTestId from "../../../fabrics/createTestId";

export const createTestIdForUniCardElement = createTestId(
    UNI_CARD_DISPLAY_NAME,
);
